import { useCallback } from 'react';
import { authApi } from './api';

export function usePasswordReset() {
  const requestPasswordReset = useCallback((email: string) => authApi.requestPasswordReset(email), []);

  const confirmPasswordReset = useCallback(
    (token: string, password: string, confirmPassword: string) =>
      authApi.confirmPasswordReset(token, password, confirmPassword),
    []
  );

  return {
    requestPasswordReset,
    confirmPasswordReset,
  };
}

